"use strict";
import { formatMonthlyLabel } from "./dateHelpers";
export const parseDataKey = (key, selectedEntities) => {
  let monthLabel;
  let entityId;
  if (key.includes(" - ") && key.includes("202")) {
    monthLabel = key;
    entityId = key.split("_")[0] || "";
  } else {
    const [entity_id, year, month] = key.split("_");
    monthLabel = month && year ? formatMonthlyLabel(parseInt(month), parseInt(year)) : key;
    entityId = entity_id;
  }
  const isAllSelected = selectedEntities == null ? void 0 : selectedEntities.some((entity) => entity.name === "All");
  const isEntitySelected = selectedEntities == null ? void 0 : selectedEntities.some(
    (entity) => entity.id.toString() === entityId
  );
  return {
    monthLabel,
    entityId,
    isAllSelected,
    isEntitySelected,
    shouldInclude: !selectedEntities || isAllSelected || isEntitySelected
  };
};
export const aggregateQuarterData = (existing, newData) => {
  if (existing.data && existing.data.reportNotFound) {
    return JSON.parse(JSON.stringify(newData));
  }
  if (newData.data && newData.data.reportNotFound) {
    return existing;
  }
  if (Array.isArray(existing.data) && Array.isArray(newData.data)) {
    const result = JSON.parse(JSON.stringify(existing));
    result.data = existing.data.concat(newData.data);
    return result;
  }
  if (typeof existing.data === "object" && !Array.isArray(existing.data) && Array.isArray(newData.data)) {
    return JSON.parse(JSON.stringify(newData));
  }
  if (typeof existing.data === "object" && typeof newData.data === "object" && !Array.isArray(existing.data) && !Array.isArray(newData.data)) {
    const result = JSON.parse(JSON.stringify(existing));
    const src = newData.data;
    const dest = result.data;
    for (const prop in src) {
      if (Object.prototype.hasOwnProperty.call(src, prop) && typeof src[prop] === "number") {
        dest[prop] = (dest[prop] || 0) + src[prop];
      }
    }
    return result;
  }
  return existing;
};
